<template>
  <div class="iv-single" :id="item.questionId">
    <p class="iv-fs-16 iv-fc-85 iv-p-t-16 iv-p-b-16 iv-fw-6">
      <span v-if="item.isRequire == 1" style="color: red">* </span>
      [单选题]&nbsp;{{index + 1}}.&nbsp;{{item.questionName}}
    </p>
    <RadioGroup v-model="item.userOptions[0]" vertical @on-change="change">
        <Radio v-for="i in item.optionList" :key="i.optionOrder" :label="i.optionOrder" :disabled="state != 1">
          <div class="iv-label iv-pull-left iv-fs-16">{{i.optionOrder}}<span class="iv-p-l-8"></span>{{i.optionInfo}}</div>
          <div class="iv-userAnswer iv-pull-left">
            <Edittext :id="id" :item="i" v-if="i.isOtherWrite == 1" />
          </div>
        </Radio>
    </RadioGroup>
  </div>
</template>
<script>
import Edittext from './edittext.vue'
export default {
  props: ['item', 'index'],
  data () {
    return {
      state: 0
    }
  },
  computed: {
    id () {
      return (this.item.userOptions === null ? [] : this.item.userOptions.toString())
    },
    isRequire () {
      return this.item.isRequire == 1 ? '[必填]' : ''
    }
  },
  created () {
    this.state = this.$route.query.state
  },
  methods: {
    change (item) {
      let isAnswer = !!this.item.userOptions[0]
      this.$emit('change', item, this.index, isAnswer)
    }
  },
  components: {
    Edittext
  }
}
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
.iv-single{
  border-bottom:1px solid rgba(0,0,0,0.09);
  .ivu-radio{
    float: left;
    margin-top: 7px;
    padding-left: 16px;
    padding-right: 14px;
  }
  .ivu-radio-wrapper{
    height: 100%;
    overflow: hidden;
    min-height: 48px;
    margin-top: 8px;
    .iv-label{    
      line-height: 46px!important;
    }
    .ivu-radio-inner{
      top: 9px;
    }
  }
  .ivu-radio-group-vertical{
    width: 100%;
  }
  .ivu-radio-wrapper-checked{
    color:#1890FF;
    background: #e6f7ff;
  }
}
</style>
